export default "__VITE_ASSET__D$Fo6pLl__"